import { IServiceEvent } from "../types/IServiceEvent";
import { Api } from "./api";

export const DeleteServiceStatus = async (
    serviceId: string,
    eventId: string
): Promise<IServiceEvent[]> => {
    const api = await Api();
    const data = { data: { eventId } };
    const apiResponse = await api
        .delete(`dashboard-ui/services/${serviceId}/status`, data)
        .then((result) => {
            return result.data.data;
        });

    return apiResponse;
};
